import { OWObject } from "../../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IFrame } from "../../IFrame";

/**
 * Kontext, nad kterým se spouští akce a vyhodnocují její práva
 */
export interface IActionExecutionContext {
    /** Objekt, nad kterým se akce spouští a nad kterým se vyhodnocují práva akce */
    readonly actualObject: OWObject | null;
    /** Frame, který je spjatý s actualObject */
    readonly ownerFrame: IFrame | null;
}
